import { IPaymentDetails } from './payment-details';
import { ICardDetails } from './card-details';
import { IDirectDebitDetails } from './direct-debit-details';
import { PaymentTypes } from '@/enums/payment-types.enum';
import { PaymentFrequency } from '../quote.interface';

export interface ISubmitQuote {
  paymentDetails: IPaymentDetails;
}

export class SubmitQuote implements ISubmitQuote {
  paymentDetails: IPaymentDetails;

  constructor() {
    this.paymentDetails = {} as IPaymentDetails;
  }

  createSubmitQuoteUsingCardPaymentDetails(paymentStoreCardDetails: any): ISubmitQuote {
    const cardDetails: ICardDetails = {
      cardType: paymentStoreCardDetails.cardType,
      cardHoldersName: paymentStoreCardDetails.cardHoldersName,
      cardExpiryMonth: paymentStoreCardDetails.cardExpiryMonth,
      cardExpiryYear: paymentStoreCardDetails.cardExpiryYear,
      token: paymentStoreCardDetails.token,
      maskedCardNumber: paymentStoreCardDetails.maskedCardNumber,
    };

    this.paymentDetails.cardDetails = cardDetails;

    return this;
  }

  createSubmitQuoteUsingBankAccountDetails(directDebitDetails: IDirectDebitDetails): ISubmitQuote {
    this.paymentDetails.directDebitDetails = directDebitDetails;

    return this;
  }

  createSubmitQuoteUsingPayLater(paymentFrequency: PaymentFrequency): ISubmitQuote {
    this.paymentDetails.cardDetails = {} as ICardDetails;
    this.paymentDetails.paymentType = PaymentTypes.PayLater;
    this.paymentDetails.paymentFrequency = paymentFrequency;
    return this;
  }
}
